import { Column } from '@miq/catalog';
import { SortEvent } from 'primeng/api';
import { TableRowReorderEvent } from 'primeng/table';

export interface PaginationSorting {
  limit?: number;
  offset?: number;
  sortField?: string;
  sortFieldType?: string;
  sortOrder?: null | 1 | -1 | 'asc' | 'desc';
  sortBy?: string;
}

export interface SingleChange {
  singleChange: any;
  parentData?: any;
  rowData?: any;
}

export interface RowChange {
  rowChange: any;
  parentData?: any;
  rowIndex?: any;
  rowData?: any;
}
export enum Position {
  BEFORE = 'before',
  AFTER = 'after',
}

export enum SortMode {
  Default = 'default',
  Dragging = 'dragging',
}

export interface MiqSortEvent extends SortEvent {
  column?: Column;
}

/**
 * @class
 * Object with detail of a row change having the specific change, parent data (if any) row index & prev state
 * plus getters with exact changes object trhough `changes` and getter to return the next state of a row
 * through `mergedChanges`
 * @param rowChange: specific change
 * @param parentData?: parentData if any
 * @param rowIndex?: row index
 * @param rowData?: previous row state
 * @returns `changes` returns object with row changes only
 * @returns `mergedChanges` it returns new row state (merge of `rowData` + `changes`)
 */
export class RowChanges {
  rowChange: any;
  parentData?: any;
  rowIndex?: any;
  rowData?: any;

  /**
   * Represents a row change.
   * @constructor
   * @param rowChange: specific change
   * @param parentData?: parentData if any
   * @param rowIndex?: row index
   * @param rowData?: prev row state
   */
  constructor({ rowChange, rowData = {}, parentData = null, rowIndex = null }: RowChange) {
    this.rowChange = rowChange;
    this.rowData = rowData;
    this.parentData = parentData;
    this.rowIndex = rowIndex;
  }

  /**
   * returns object with row changes only
   * @returns {any} object with row changes only
   */
  public get changes() {
    return Object.entries(this.rowChange).reduce(
      (acc, [key, change]: [string, any]) => ({ ...acc, [key]: change.value }),
      {}
    );
  }

  /**
   * it returns new row state
   * @returns {any} current state merging all changes applied to the row (new state of the row)
   */
  public get mergedChanges() {
    return { ...this.rowData, ...this.changes };
  }
}

export class RowReorderEvent implements TableRowReorderEvent {
  public dragIndex: number;
  public dropIndex: number;
  constructor(opts: TableRowReorderEvent) {
    Object.assign(this, opts);
  }
}

export class ChildRowReorderEvent extends RowReorderEvent {
  parentRow: Record<string, any>;
  constructor(opts: TableRowReorderEvent & { parentRow: Record<string, any> }) {
    super(opts);
    this.parentRow = opts.parentRow;
  }
}
